import { createRouter, createWebHistory } from 'vue-router';
import { i18n } from '@/plugins/i18n';
import { useAuthStore } from '@/store/authStore';

declare module 'vue-router' {
  interface RouteMeta {
    // Reachable without a session
    public?: boolean;
    // i18n key of the page title
    title?: string;
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: () => import('@/components/layout/AppShell.vue'),
      children: [
        {
          path: '',
          name: 'overview',
          component: () => import('@/views/OverviewView.vue'),
          meta: { title: 'overview.title' },
        },
        {
          path: 'vente-de-leads',
          name: 'leads',
          component: () => import('@/views/LeadsView.vue'),
          meta: { title: 'regions.leads.title' },
        },
        {
          path: 'premium',
          name: 'premium',
          component: () => import('@/views/PremiumView.vue'),
          meta: { title: 'premium.title' },
        },
        {
          path: 'online',
          name: 'online',
          component: () => import('@/views/OnlineView.vue'),
          meta: { title: 'regions.online.title' },
        },
        {
          path: 'mot-de-passe',
          name: 'password',
          component: () => import('@/views/PasswordView.vue'),
          meta: { title: 'auth.password.title' },
        },
        {
          path: 'gestion-des-roles',
          name: 'roles',
          component: () => import('@/views/RolesView.vue'),
          meta: { title: 'accounts.title' },
        },
      ],
    },
    {
      path: '/connexion',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true, title: 'auth.login.title' },
    },
    {
      // Also the target of the reset link sent by email: ?token=...
      path: '/mot-de-passe-oublie',
      name: 'forgotPassword',
      component: () => import('@/views/ForgotPasswordView.vue'),
      meta: { public: true, title: 'auth.recovery.title' },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.ready) {
    await auth.init();
  }
  if (to.meta.public) {
    return to.name === 'login' && auth.isLogged ? { name: 'overview' } : true;
  }
  if (!auth.isLogged) {
    return { name: 'login', query: to.fullPath === '/' ? {} : { u: to.fullPath } };
  }
  return true;
});

router.afterEach((to) => {
  const { t } = i18n.global;
  document.title = to.meta.title ? t('app.pageTitle', { page: t(to.meta.title) }) : t('app.title');
});

export default router;
